import * as React from 'react';
import {FormattedMessage, defineMessages} from 'react-intl';

import {Link, css, view} from '@sail/ui/deprecated';

export const messages = defineMessages({
  sharingNotice: {
    id: 'support_conversations_client.connectPlatformSharingNotice',
    description:
      'The text for a notice informing connected accounts that their support cases may be shown to their platform account',
    defaultMessage: 'Support conversations may be shared with your platform.',
  },
  sharingNoticeWithPlatformName: {
    id: 'support_conversations_client.connectPlatformSharingNotice.withPlatformName',
    description:
      'The text for a notice informing connected accounts that their support cases may be shown to their platform account',
    defaultMessage:
      'Support conversations may be shared with {platformNickname}.',
  },
  viewDetailsLabel: {
    id: 'support_conversations_client.connectPlatformSharingNotice.viewDetailsLabel',
    description:
      'Text for a button label that links to a support article with more information',
    defaultMessage: 'View details',
  },
});

export function ConnectPlatformSharingNotice({
  platformNickname,
}: {
  platformNickname?: string;
}): React.ReactElement {
  return (
    <view.div
      css={{margin: 'medium', marginTop: css.value('auto'), font: 'caption'}}
    >
      <view.p
        css={{
          borderTop: css.value('1px solid $borderColor.neutral'),
          paddingTop: 'medium',
        }}
      >
        {platformNickname ? (
          <FormattedMessage
            {...messages.sharingNoticeWithPlatformName}
            values={{platformNickname}}
          />
        ) : (
          <FormattedMessage {...messages.sharingNotice} />
        )}{' '}
        <Link
          type="primary"
          href="https://support.stripe.com/questions/support-case-visibility-for-accounts-connected-to-third-party-platforms"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage {...messages.viewDetailsLabel} />
        </Link>
      </view.p>
    </view.div>
  );
}
